export default {
  'message': {
    'title': ['@:terms.phone-number를', '입력해주세요.'],
    'description': '본인확인을 위해 필요합니다.',
  },
  'certificate-number': '@:terms.certificate-number',
  'phone-number': '@:terms.phone-number (인증 횟수 한도: 1일 3회)',
  'certificate-time': '@:terms.certificae-time',
  'placeholder': {
    'certificate-number': '전송된 @:terms.certificate-number를 입력해주세요.',
  },
  'verification': {
    'required': {
      'certificate-number': '@:terms.certificate-number를 입력해주세요.',
      'phone-number': '@:terms.phone-number를 입력해주세요.',
    },
    'format': {
      'phone-number': '@:terms.phone-number 형식에 맞게 입력해주세요.',
    },
    'request-limit': '문자인증 횟수를 초과하였습니다.',
    'time-over': '@:terms.certificate-time이 초과되었습니다. ' +
      '@:terms.certificate-number를 다시 요청해주세요.',
    'certificate-failed': '인증번호가 일치하지 않습니다. @:terms.certificate-number를 다시 입력해주세요.',
  },
  'error': {
    'request': '@:terms.certificate-number 전송에 실패하였습니다.',
    'certificate': '@:terms.certificate-number 인증에 실패하였습니다.',
    'register': '@:terms.phone-number 저장에 실패하였습니다.',
  },
  'certificate-success': '인증 성공',
  'certificate-number-notice': {
    'limit': '@:terms.certificate-time이 {limit} 남았습니다.',
    'request-limit': '문자인증 횟수한도 : 1일 3회',
  },
  'certificate-number-button': {
    'request': '@:terms.certificate-number 요청',

    're-request': '@:terms.certificate-number 재요청',
    'submit': '@:terms.certificate-number 확인',
  },
  'min': '  | {min}@:terms.min | {min}@:terms.min',
  'sec': '  | {sec}@:terms.sec | {sec}@:terms.sec',
  'next': '@:terms.next',
  'required': '@:terms.required',
  'confirm': '@:terms.confirm',
}
